import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import * as Sentry from '@sentry/browser';
import { CustomValidators } from 'ng2-validation';
import { ChangePasswordModel } from '../models/change-password.model';
import { BaseFormComponent } from '../../../shared/components/refactor-components/base-form/base-form.component';
import { Messages } from '../../../shared/constants/messages.constant';
import { AppRoutes } from '../../../shared/constants/routes/routes.constant';
import { RecoveryService } from '../services/recovery.service';

@Component({
  selector: 'change-password',
  templateUrl: '../templates/change-password.html',
  styleUrls: ['../scss/change-password.scss'],
})
export class ChangePasswordComponent extends BaseFormComponent {
  changePassword: ChangePasswordModel = new ChangePasswordModel();
  errors: any;
  success: Array<string>;
  isUser: boolean = true;
  showLoading: boolean;
  passwordShown: object = {};

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private recoveryService: RecoveryService
  ) {
    super(
      { email: '', old_password: '', password: '', password_confirmation: '' },
      {
        email: {
          required: Messages.EMAIL_REQUIRED,
          email: Messages.EMAIL_REQUIRED,
        },
        old_password: {
          required: Messages.OLD_PASSWORD_REQUIRED,
          minlength: Messages.PASSWORD_MINLENGTH,
        },
        password: {
          required: Messages.PASSWORD_REQUIRED,
          minlength: Messages.PASSWORD_MINLENGTH,
        },
        password_confirmation: {
          equalTo: Messages.PASSWORD_EQUAL,
        },
      },
      fb
    );
  }

  ngOnInit() {
    this.buildForm();
    const referral = localStorage.getItem('referral');
    const role = JSON.parse(localStorage.getItem('user')).role_name;
    if (referral.toUpperCase() === 'iClinic'.toUpperCase() && role !== 'admin') {
      this.router.navigate(['/pages/gestao-financeira/dashboard/resumo']);
    }
  }

  initializeForm(): FormGroup {
    let password: FormControl = new FormControl(this.changePassword.password, [
      Validators.required,
      Validators.minLength(6),
    ]);
    let password_confirmation: FormControl = new FormControl(
      this.changePassword.password_confirmation,
      CustomValidators.equalTo(password)
    );

    this.passwordShown = {
      old_password: false,
      password: false,
      password_confirmation: false,
    };

    return this.fb.group({
      old_password: [
        this.changePassword.old_password,
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
      password: password,
      password_confirmation: password_confirmation,
    });
  }

  sendForm(): any {
    let values = this.form.value;
    this.showLoading = true;
    this.changePassword = this.form.value;
    this.route.params.subscribe((params: any) => {
      this.changePassword.token = params['token'];
    });
    return this.recoveryService
      .changePassword(values.old_password, values.password, values.password_confirmation)
      .subscribe(
        (res) => {
          this.handleResponseSuccess(res);
        },
        (res) => {
          this.handleResponseErrors(res);
        }
      );
  }

  handleResponseSuccess(res: any) {
    this.errors = '';
    this.success = res.messages;
    setTimeout(() => {
      this.router.navigate([AppRoutes.LOGIN]);
    }, 3000);
  }

  handleResponseErrors(errors) {
    this.success = [];
    if ((errors.error.error = 'Unauthenticated.')) {
      this.errors = 'A senha antiga não está correta';
    } else {
      this.errors = errors.error.error;
    }
    errors && Sentry.captureException(errors);
    this.showLoading = false;
  }

  handleErrors() {}

  togglePasswordVisiblity(field: string) {
    let element = <HTMLInputElement>document.querySelector(`input[name=${field}]`);
    element.type == 'password' ? (element.type = 'text') : (element.type = 'password');
    element.type == 'password'
      ? (this.passwordShown[field] = false)
      : (this.passwordShown[field] = true);
  }
}
